import React, { useState } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import * as actions from '../redux/actions'
import jwt from 'jsonwebtoken'

import { auth, defaultEmail, defaultPassword } from '../services/defaultProps'

import text from '../constants/Login'
import '../styles/containers/Login.css'

import LoginHeader from '../components/LoginHeader'
import FormInput from '../components/FormInput'
import FormButton from '../components/FormButton'
import FormButtonWithIcon from '../components/FormButtonWithIcon'

import 'react-toastify/dist/ReactToastify.css'
import { Link } from 'react-router-dom'
import API from '../services/Api'
import useLanguage from '../hooks/useLanguage'

const Login = props => {
  const [email, setEmail] = useState(defaultEmail)
  const [password, setPassword] = useState(defaultPassword)
  const [error, setError] = useState(null)
  const language = useLanguage()
  const [loading, setLoading] = useState(false)

  const login = async () => {
    setError(null)

    try {
      const res = await API.localAuth(email, password)

      const token = res.headers.authorization.split(' ').pop()
      const userJwt = jwt.decode(token)

      if (userJwt.auth !== auth.user) {
        throw new Error(403)
      }

      const id = res.body.id

      const userResponse = API.getUser(token)
      const profileResponse = API.getProfile(token, id)
      const profileImageResponse = API.getProfileImage(token, id)
      const styleImageResponse = API.getStyleImage(token)
      const personalColorResponse = API.getPersonalColor(token, id)
      const closetResponse = API.getCloset(token, id)
      const moodboardResponse = API.getMoodboard(token, id)
      const moodboardTemplateResponse = API.getMoodboardTemplate(token)
      const shopListResponse = API.getShopList(token)
      const shopListTemplateResponse = API.getShopListTemplate(token)
      const personalColoringResponse = API.getPersonalColor(token, id)
      const agendaResponse = API.getAgenda(token, id)
      const personalContrastResponse = API.getPersonalContrast(token)
      const openCartResponse = API.getOpenCart(token)
      const payerInfoResponse = API.getPayerInfo(token)
      const deliveryAddressResponse = API.getDeliveryAddress(token)
      const cardResponse = API.getCard(token)
      const ordersResponse = API.getOrders(token)
      const blockStatusResponse = API.getBlockStatus(token)
      const billingListResponse = API.getBillingList(token)

      const [
        user,
        profile,
        userProfile,
        userStyle,
        userPersonalColor,
        userCloset,
        moodboard,
        moodboardTemplate,
        shopList,
        shopListTemplate,
        personalColoring,
        agenda,
        userContrast,
        cart,
        payerInfo,
        deliveryAddress,
        card,
        orders,
        blockStatus,
        billingList
      ] = await Promise.all([
        userResponse,
        profileResponse,
        profileImageResponse,
        styleImageResponse,
        personalColorResponse,
        closetResponse,
        moodboardResponse,
        moodboardTemplateResponse,
        shopListResponse,
        shopListTemplateResponse,
        personalColoringResponse,
        agendaResponse,
        personalContrastResponse,
        openCartResponse,
        payerInfoResponse,
        deliveryAddressResponse,
        cardResponse,
        ordersResponse,
        blockStatusResponse,
        billingListResponse
      ])

      props.setFetchedInLogin(true)
      props.setUser(user)
      props.setUserAttribute(profile)
      props.setUserAttribute(userProfile)
      props.setUserAttribute({ userStyle })
      props.setUserAttribute(userCloset)
      props.setUserAttribute(userPersonalColor)
      props.setUserAttribute(moodboard)
      props.setUserAttribute({ moodboardTemplate })
      props.setUserAttribute(shopList)
      props.setUserAttribute({ shopListTemplate })
      props.setUserAttribute(personalColoring)
      props.setUserAttribute({ agenda })
      props.setUserAttribute(userContrast)
      props.setCart({cart})
      props.setPayerInfo({payerInfo})
      props.setDeliveryAddress({deliveryAddress})
      props.setPayerInfo({card})
      props.setOrders({orders})
      props.setUserAttribute({ lastFetch: moment() })
      props.setToken(token)
      props.setIsAppBlocked(blockStatus)
      props.setPendingBillings(billingList)
      props.setAllBillings(billingList)
    } catch (err) {
      console.error('Error on login', err)
      if (err.errorMessage) {
        setError(err.errorMessage)
      }
    }
  }

  const submit = async e => {
    e.preventDefault()
    if (loading) return

    setLoading(true)
    await login()
    setLoading(false)
  }

  const userAgent = navigator.userAgent
  const iOS = !!userAgent.match(/iPhone|iPad|iPod/)

  return (
    <div className='login-screen-container'>
      <LoginHeader />
      <form className='login-screen-form' onSubmit={submit}>
        <p className='login-screen-access-account'>{text.acess[language]}</p>
        <FormInput className='login-screen-input' placeholder={text.email[language]} value={email}
          onChange={e => setEmail(e.target.value)} />
        <FormInput className='login-screen-input' placeholder={text.password[language]} type='password' value={password}
          onChange={e => setPassword(e.target.value)} />
        <Link to='/esqueci-a-senha' className='login-screen-forgot-password-button'>{text.forget[language]}</Link>
        {error !== null && <p className='login-screen-error'><strong>{error}</strong></p>}
        <FormButton loading={loading}>
          {text.login[language]}
        </FormButton>
        {iOS && (
          <FormButtonWithIcon onClick={() => window.open('https://admin.mosty.app/', '_blank')} type='button'>
            {text.amConsultant[language]}
          </FormButtonWithIcon>
        )}
      </form>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    ...state.userReducer
  }
}

export default connect(mapStateToProps, actions)(Login)



// WEBPACK FOOTER //
// ./src/containers/Login.js